import LogoIcon from '@assets/images/logo.png';
import IconLogo from '@assets/images/icon-logo.png';
import Logo2 from '@assets/images/logo-light.png';
import ImgShortStay from '@assets/images/img-short-stay.png';
import ImgBusinessTravel from '@assets/images/img-business-travel.png';
import ImgFamilyVacation from '@assets/images/img-family-vacation.png';
import ImgCoupleFriendly from '@assets/images/img-couple-friendly.png';
import ImgGroupTravel from '@assets/images/img-group-travel.png';
import ImgSoloTravel from '@assets/images/img-solo-travel.png';
import ImgChoose from '@assets/images/img-choose.jpg';
import IconChoose1 from '@assets/images/icon-choose1.png';
import IconChoose2 from '@assets/images/icon-choose2.png';
import IconChoose3 from '@assets/images/icon-choose3.png';
import IconChoose4 from '@assets/images/icon-choose4.png';
import IconChoose5 from '@assets/images/icon-choose5.png';
import IconFeature1 from '@assets/images/icon-feature1.png';
import IconFeature2 from '@assets/images/icon-feature2.png';
import IconFeature3 from '@assets/images/icon-feature3.png';
import IconFeature4 from '@assets/images/icon-feature4.png';
import IconFeature5 from '@assets/images/icon-feature5.png';
import IconQuote from '@assets/images/icon-quote.png';
import SatisfiedCustomer from '@assets/images/satisfied-customers.png';
import ImgTestimonial from '@assets/images/img-testimonial.png';
import IconRatingStar from '@assets/images/icon-rating-star.png';
import AppStore from '@assets/images/img-appStore.png';
import PlayStore from '@assets/images/img-playStore.png';
import Scan1 from '@assets/images/footer-scan.png';
import Scan2 from '@assets/images/scan2.png';
import PaymentOptions from '@assets/images/img-payment-options.png';
import IconPhone from '@assets/images/icon-phone.png';
import IconAc from '@assets/images/icon-ac.png';
import IconWifi from '@assets/images/icon-wifi.png';
import IconLed from '@assets/images/icon-led.png';
import IconPayOnline from '@assets/images/icon-pay-online.png';
import IconPayPartial from '@assets/images/icon-pay-partial.png';
import IconPayHotel from '@assets/images/icon-pay-hotel.png';
import ImgProfile from '@assets/images/img-profile.png';
import IconWallet from '@assets/images/icon-wallet.png';
import ImgLoginOff from '@assets/images/img-login-off.png';
import IconLoyalty from '@assets/images/icon-loyalty.png';
import ImgNoData from '@assets/images/img-no-data.png';
import ImgSoldout from '@assets/images/soldOut.png';
import NoImage from '@assets/images/no-image.jpeg';
import Banner1 from '@assets/images/banner1.jpg';
import ImgNotFound from '@assets/images/img-not-found.png';
import Video1 from '@assets/images/video.mp4';

import ImgBannerHourly from '@assets/images/banner-hourly.png';
import ImgHourly from '@assets/images/img-hourly-stay.jpeg';
import ImgNoImage from '@assets/images/img-no-image.jpg';


import IconBusiness from '@assets/icons/icon-business.svg';
import IconCouple from '@assets/icons/icon-couple.svg';
import IconFamily from '@assets/icons/icon-family.svg';
import IconShort from '@assets/icons/icon-short.svg';
import IconProfile from '@assets/icons/icon-profile.png';

import IconStay from '@assets/images/img-hour-stay.png';


const ImagesData = {
    LogoIcon,
    IconLogo,
    Logo2,
    ImgShortStay,
    ImgBusinessTravel,
    ImgFamilyVacation,
    ImgCoupleFriendly,
    ImgGroupTravel,
    ImgSoloTravel,
    ImgChoose,
    IconChoose1,
    IconChoose2,
    IconChoose3,
    IconChoose4,
    IconChoose5,
    IconFeature1,
    IconFeature2,
    IconFeature3,
    IconFeature4,
    IconFeature5,
    IconQuote,
    SatisfiedCustomer,
    ImgTestimonial,
    IconRatingStar,
    AppStore,
    PlayStore,
    Scan1,
    Scan2,
    PaymentOptions,
    IconPhone,
    IconAc,
    IconWifi,
    IconLed,
    IconPayOnline,
    IconPayPartial,
    IconPayHotel,
    ImgProfile,
    IconWallet,
    ImgLoginOff,
    IconLoyalty,
    ImgNoData,
    ImgSoldout,
    NoImage,
    Banner1,
    ImgNotFound,
    Video1,
    ImgBannerHourly,
    ImgHourly,
    ImgNoImage,

    IconBusiness,
    IconCouple,
    IconFamily,
    IconShort,
    IconProfile,

    IconStay
}

export default ImagesData